/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useIsomorphicLayoutEffect } from "react-use";
import { isEmpty } from "../../../utils/helpers/helpers";

import { ERROR_CODE_NEED_VIP } from "../../arena/utils/constants";
import ModalEarnDiamond from "../../common/components/ModalEarnDiamond";
import AlertDialog from "../../common/dialog/AlertDialog";
import { commonActions } from "../../common/redux/actions";
import { TCommonState } from "../../common/utils/type";
import { quizActions } from "../../topics/redux/actions";
import ModalConfirmLogin from "../components/ModalConfirmLogin";
import ModalConfirmPremium from "../components/ModalConfirmPremium";
import SubjectsView from "../components/SubjectsView";
import { subjectActions } from "../redux/actions";
import { ACCESS_LEVEL } from "../utils/contants";
import { TypeInitSubjectReducer } from "../utils/type";

function Subjects({ props }) {
  const { grade, listSubject, dataTopics, bookId: bookIdSSR } = props;
  const router = useRouter();
  const intl = useIntl();
  const { listTypeCard, notify, pageCurrent } = useSelector(
    (state: { subject: TypeInitSubjectReducer }) => state.subject
  );
  const [openModalReport, setOpenModalReport] = React.useState(false);
  const dataUserInfos = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const isNotLogin = isEmpty(dataUserInfos?.member);
  const [hideItems, setHideItems] = React.useState<number[]>([]);
  const [confirmDiamond, setConfirmDiamond] = React.useState<any>();
  const [cardId, setCardId] = React.useState<number>(0);
  const [openAlertDialogViewAds, setOpenAlertDialogViewAds] = React.useState(false);
  const [openModalConfirmLogin, setOpenModalConfirmLogin] = React.useState<boolean>(false);
  const [openModalConfirmPremium, setOpenModalConfirmPremium] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const [quizPrice, setQuizPrice] = React.useState(0);
  const handleConfirmModalPremium = () => {
    router.push("/kim-cuong/nang-cap-vip");
  };
  const handleOpenModalConfirmPremium = () => {
    setOpenModalConfirmPremium(true);
  };
  const handleOpenModalReport = (ele) => {
    setCardId(ele?.id);
    setOpenModalReport(true);
  };
  const handleCloseModalReport = () => {
    setOpenModalReport(false);
  };

  const handleCloseModalConfirmPremium = () => {
    setOpenModalConfirmPremium(false);
  };
  const { bookId, directUrl } = useSelector((state: { commonNew: TCommonState }) => state.commonNew);
  const actionCommon = useSelector((state: { commonNew: TCommonState }) => state.commonNew.action);
  const handleOpenModalConfirmLogin = (accessLevel) => {
    if (ACCESS_LEVEL.PREMIUM === accessLevel && (dataUserInfos?.member?.vip_to as number) <= moment().unix()) {
    } else setOpenModalConfirmLogin(true);
  };
  const handleChooseBook = (book) => {
    const slug = listSubject?.find((item) => item?.subject?.id === Number(book))?.subject?.slug;
    router.replace(`/${grade}/${slug}`);
  };

  const handleClickLink = (url: string, price?: number, isConfirm?: boolean) => {
    dispatch(quizActions.handleSetIsRedoOrContinue(""));
    dispatch(commonActions.handleDirectUrl(url));
    if (price) {
      setQuizPrice(price);
      setConfirmDiamond(isConfirm || false);
      if (!isConfirm) {
        router.push(url);
      }
    } else {
      router.push(url);
    }
  };

  const checkIsHideItem = (itemId: number) => {
    if (hideItems?.length > 0) {
      return hideItems?.findIndex((e: number) => e === itemId) > -1;
    }
    return false;
  };
  const handleSetHideItems = (itemId: number) => {
    if (checkIsHideItem(itemId)) {
      setHideItems(hideItems.filter((e: number) => e !== itemId));
    } else {
      setHideItems(hideItems.length > 0 ? [...hideItems, itemId] : [itemId]);
    }
  };
  useEffect(() => {
    return () => {
      dispatch(subjectActions.handleChangeTabSubject({}));
    };
  }, []);
  useIsomorphicLayoutEffect(() => {
    if (actionCommon?.type === "LOGIN_SUCCESS" && !isEmpty(directUrl)) {
      if (!confirmDiamond) {
        router.push(directUrl);
        dispatch(commonActions.handleOpenModalLogin(false));
      } else {
        router.replace(router.asPath);
      }
    }
  }, [actionCommon]);

  return (
    <>
      <SubjectsView
        pageCurrent={pageCurrent}
        handleSetHideItems={handleSetHideItems}
        checkIsHideItem={checkIsHideItem}
        subjects={listSubject}
        listTypeCard={listTypeCard}
        dataTopics={dataTopics}
        handleClickLink={handleClickLink}
        handleChooseBook={handleChooseBook}
        bookId={bookId}
        handleOpenModalConfirmLogin={handleOpenModalConfirmLogin}
        handleOpenModalConfirmPremium={handleOpenModalConfirmPremium}
        openModalReport={openModalReport}
        handleOpenModalReport={handleOpenModalReport}
        handleCloseModalReport={handleCloseModalReport}
        cardId={cardId}
        // fetchTopics={fetchTopics}
      />
      {!!confirmDiamond && !isNotLogin && (
        <AlertDialog
          open={!!confirmDiamond && !isNotLogin}
          setOpen={setConfirmDiamond}
          title={intl.formatMessage({ id: "common.notification" })}
          triggerFunc={() => {
            setConfirmDiamond(false);
            const memberDiamond = dataUserInfos.member?.diamond || 0;
            if (quizPrice - memberDiamond > 5) {
              dispatch(subjectActions.handleOpenModalEarnDiamond(true));
            } else if (quizPrice - memberDiamond < 5 && quizPrice - memberDiamond > 0) {
              setOpenAlertDialogViewAds(true);
            } else {
              router.push(directUrl);
            }
          }}
          contentKey="Dialog.DiamonQuizConfirmMsg"
          buttonOkKey="common.ok"
        />
      )}
      {notify.isOpenDialog && (
        <AlertDialog
          open={notify.isOpenDialog}
          setOpen={() => dispatch(subjectActions.handleCleanNotify())}
          title={intl.formatMessage({ id: "common.notification" })}
          content={`${notify.message}(${notify?.errorCode})`}
          triggerFunc={() => {
            if (notify.errorCode === ERROR_CODE_NEED_VIP) {
              dispatch(subjectActions.handleCleanNotify());
              router.push("/kim-cuong/nang-cap-vip");
            }
            dispatch(subjectActions.handleCleanNotify());
          }}
          contentKey="common.note"
          buttonOkKey="common.ok"
          isHideCancel={!(notify.errorCode === ERROR_CODE_NEED_VIP)}
          cancelFunc={() => {
            dispatch(subjectActions.handleCleanNotify);
            router.back();
          }}
        />
      )}
      {!bookIdSSR && !listSubject.length && (
        <AlertDialog
          open={!bookIdSSR && !listSubject.length}
          setOpen={() => dispatch(subjectActions.handleCleanNotify())}
          title={intl.formatMessage({ id: "common.notification" })}
          content={intl.formatMessage({ id: "common.somethingWrong" })}
          triggerFunc={() => {
            window.location.replace("/");
          }}
          isHideCancel
          buttonOkKey="common.backToHome"
        />
      )}

      {openModalConfirmLogin && (
        <ModalConfirmLogin
          open={openModalConfirmLogin}
          onConfirm={() => {
            setOpenModalConfirmLogin(false);
            dispatch(commonActions.handleOpenModalLogin(true));
          }}
          handleClose={() => setOpenModalConfirmLogin(false)}
        />
      )}
      {openModalConfirmPremium && (
        <ModalConfirmPremium
          onConfirm={handleConfirmModalPremium}
          open={openModalConfirmPremium}
          styles={{}}
          handleClose={handleCloseModalConfirmPremium}
        />
      )}
      <ModalEarnDiamond
        openAlertDialogViewAds={openAlertDialogViewAds}
        setOpenAlertDialogViewAds={setOpenAlertDialogViewAds}
        triggerFunc={() => router.push(directUrl)}
      />
    </>
  );
}

export default Subjects;
